module.exports = __webpack_public_path__ + "media/images/athletes/1713-ad6b4567d773bd4211e3e1c968a45d3e.png";